import { render, staticRenderFns } from "./device.vue?vue&type=template&id=22b25a76&scoped=true"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"
import style0 from "./device.vue?vue&type=style&index=0&id=22b25a76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b25a76",
  null
  
)

export default component.exports